import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid, Modal, Stack, Step, Stepper, StepLabel } from '@mui/material';
import { isEmpty } from 'lodash';

const TutorialModal = ({ openModal, setOpenModal, properties }) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = properties.length;

  const handleNext = () => {
    if (activeStep === steps - 1) {
      setOpenModal(false);
      setActiveStep(0);
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const adjustURL = url => {
    let adjustedURL = url;
    if (!/^https?:\/\//i.test(url)) {
      adjustedURL = `https://${url}`;
    }
    return adjustedURL;
  };

  const renderBox = property => {
    if (property && property.type) {
      switch (property.type) {
        case 'imagen':
          return <img height="100%" src={property.value} alt="imagen" className="mb-3 mt-1" />;
        case 'url':
        case 'pdf':
          return (
            <iframe
              src={adjustURL(property.value)}
              height="100%"
              align="center"
              title="pdf"
              width="90%"
            />
          );

        default:
          return (
            <iframe src={adjustURL(property.value)} height="100%" align="center" title="pdf" />
          );
      }
    } else {
      return <div>No valid property</div>;
    }
  };

  const body = (
    <Box backgroundColor="white" width="95vw" height="95vh">
      <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
        <Grid container direction="row" justifyContent="space-around" spacing={3}>
          <Grid item xs={10} sx={{ display: 'flex' }}>
            <Box sx={{ width: '90%' }}>
              {!isEmpty(properties) && (
                <Stepper activeStep={1} alternativeLabel>
                  {properties.map(label => (
                    <Step key={label.value}>
                      {label.title && !isEmpty(label.title) ? (
                        <StepLabel>{label.title}</StepLabel>
                      ) : (
                        <StepLabel />
                      )}
                    </Step>
                  ))}
                </Stepper>
              )}
            </Box>
          </Grid>
          <Grid item xs={2} sx={{ justifyContent: 'space-around', display: 'flex' }}>
            <Button
              color="success"
              variant="outlined"
              onClick={() => {
                setOpenModal(false);
                setActiveStep(0);
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box height="85%" width="100%" ml={3} mr={3} justifyContent="center">
        {renderBox(properties[activeStep])}
      </Box>
      <Box display="flex" height="5%" width="100%">
        <Stack direction="row" alignItems="center">
          <Button
            disabled={activeStep === 0}
            sx={{
              color: '#2A3F90'
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              color: 'white',
              backgroundColor: '#2A3F90'
            }}
            onClick={handleNext}
          >
            {activeStep === steps - 1 ? 'Finish' : 'Next'}
          </Button>
        </Stack>
      </Box>
    </Box>
  );

  return (
    <>
      <Modal
        open={openModal}
        disableBackdropClick
        style={{
          position: 'absolute',
          bgcolor: 'white',
          top: '2.5vh',
          left: '2.5vw'
        }}
      >
        {body}
      </Modal>
    </>
  );
};
export default TutorialModal;

TutorialModal.defaultProps = {};
TutorialModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  properties: PropTypes.array.isRequired
};
